import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

export default function Login() {
  const { loginWith } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [forgotOpen, setForgotOpen] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      loginWith(data.token, data.user);
      navigate("/");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  const forgot = async () => {
    try {
      await api.post("/auth/forgot-password", { email: forgotEmail });
      toast.success("Falls die E-Mail existiert, wurde ein Link versendet.");
      setForgotOpen(false);
    } catch {
      toast.error("Vorgang fehlgeschlagen.");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12 bg-background">
        <div className="w-full max-w-md">
          <Logo className="mb-10 justify-center" imgClass="h-28" />
          <h1 className="text-3xl font-serif mb-2">Anmelden</h1>
          <p className="text-muted-foreground mb-8 text-sm">
            Willkommen zurück. Bitte melden Sie sich mit Ihren Zugangsdaten an.
          </p>
          {!forgotOpen ? (
            <form onSubmit={submit} className="space-y-5" data-testid="login-form">
              <div className="space-y-2">
                <Label htmlFor="email">E-Mail-Adresse</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="password">Passwort</Label>
                <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
              </div>
              <Button type="submit" className="w-full" disabled={busy} data-testid="login-submit-button">
                {busy ? "Anmeldung läuft…" : "Anmelden"}
              </Button>
              <button type="button" onClick={() => setForgotOpen(true)} className="text-sm text-primary hover:underline" data-testid="forgot-link">
                Passwort vergessen?
              </button>
            </form>
          ) : (
            <div className="space-y-5" data-testid="forgot-form">
              <div className="space-y-2">
                <Label htmlFor="fe">E-Mail-Adresse</Label>
                <Input id="fe" type="email" value={forgotEmail} onChange={(e) => setForgotEmail(e.target.value)} data-testid="forgot-email" />
              </div>
              <Button onClick={forgot} className="w-full" data-testid="forgot-submit">Link anfordern</Button>
              <button type="button" onClick={() => setForgotOpen(false)} className="text-sm text-primary hover:underline">Zurück zur Anmeldung</button>
            </div>
          )}
          <p className="text-xs text-muted-foreground mt-10">
            Eltern registrieren sich über den QR-Code bzw. Link ihres Kurses.
          </p>
          <Link to="/impressum" className="text-xs text-muted-foreground hover:underline mt-2 inline-block">Impressum</Link>
        </div>
    </div>
  );
}
